<template>
  <button
    :class="{ disabled: !isProceedEnable || isLoading, loading: isLoading }"
    class="proceed-btn"
  >
    {{ isLoading ? '' : 'Proceed' }}
  </button>
</template>

<script>
export default {
  name: 'ProceedButton',
  props: {
    isProceedEnable: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.pf-tnx .proceed-btn {
  background-color: #dee965;
  color: #022d2d;
  border: 1px solid #dee965;
  font-family: 'FoundersGrotesk', serif;
  font-weight: 700;

  &.disabled {
    color: #022d2d;
  }

  &.loading::after {
    border-top-color: #022d2d;
  }
}
</style>
